export enum FileErrorCode {
  FILE_INVALID_TYPE = 'file-invalid-type',
}
